// eslint-disable-next-line import/prefer-default-export
export function setUser(email, ...props) {
  window.bugsnagClient.user = {
    email,
    ...props,
  };
}
